module.exports = __webpack_public_path__ + "img/stock1.369c1dc6.png";